var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("TreeSelect", {
    ref: "tree",
    staticClass: "bj-tree-select",
    class: [_vm.size],
    attrs: {
      multiple: _vm.multiple,
      options: _vm.treeData,
      "no-results-text": "暂无结果",
      "clear-value-text": "删除",
      placeholder: _vm.$t("chooseText"),
      normalizer: _vm.normalizer,
      disabled: _vm.disabled,
      "always-open": _vm.alwaysOpen,
      "open-on-focus": true,
      clearable: "",
    },
    on: { open: _vm.handleOpen },
    model: {
      value: _vm.id,
      callback: function ($$v) {
        _vm.id = $$v
      },
      expression: "id",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }